// 拡張子 → Monaco言語マッピング
export const EXTENSION_TO_LANGUAGE: Record<string, string> = {
  'ts': 'typescript',
  'tsx': 'typescript',
  'js': 'javascript',
  'jsx': 'javascript',
  'py': 'python',
  'rb': 'ruby',
  'go': 'go',
  'rs': 'rust',
  'java': 'java',
  'kt': 'kotlin',
  'swift': 'swift',
  'c': 'c',
  'cpp': 'cpp',
  'cs': 'csharp',
  'php': 'php',
  'html': 'html',
  'css': 'css',
  'scss': 'scss',
  'json': 'json',
  'xml': 'xml',
  'yaml': 'yaml',
  'yml': 'yaml',
  'toml': 'toml',
  'md': 'markdown',
  'sql': 'sql',
  'sh': 'shell',
  'bash': 'shell',
  'csv': 'plaintext',
};

// バイナリ拡張子
export const BINARY_EXTENSIONS = new Set([
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'ico',
  'bmp',
  'svg',
  'mp3',
  'mp4',
  'wav',
  'webm',
  'avi',
  'mov',
  'zip',
  'tar',
  'gz',
  'rar',
  '7z',
  'pdf',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
  'woff',
  'woff2',
  'ttf',
  'otf',
  'eot',
  'exe',
  'dll',
  'so',
  'dylib',
  'bin',
  'wasm',
]);

/**
 * ファイルパスから拡張子を取得し、Monaco Editorの言語名を返す
 */
export function getLanguageFromPath(filePath: string): string {
  const parts = filePath.split('.');
  if (parts.length < 2) {
    return '';
  }
  const extension = parts[parts.length - 1].toLowerCase();
  return EXTENSION_TO_LANGUAGE[extension] || '';
}

/**
 * ファイルパスの拡張子がバイナリファイルかどうかを判定
 */
export function isBinaryExtension(filePath: string): boolean {
  const parts = filePath.split('.');
  if (parts.length < 2) {
    return false;
  }
  const extension = parts[parts.length - 1].toLowerCase();
  return BINARY_EXTENSIONS.has(extension);
}
